import {getErrorAction, getSuccessAction} from '../utility'
import {actions} from './actions'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const initialState = {
  authenticating: false,
  user: null
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.LOGIN:
      return {
        ...state,
        authenticating: true
      }
    case getSuccessAction(actions.LOGIN):
      return {
        ...state,
        user: action.user,
        authenticating: false,
        error: false
      }
    case getErrorAction(actions.LOGIN):
      return {
        ...state,
        user: null,
        authenticating: false,
        error: true
      }
    case actions.LOGOUT:
      window.localStorage.removeItem(process.env.REACT_APP_AUTH_STORAGE_KEY)
      return {
        ...state,
        user: null,
        authenticating: false
      }
    default:
      return state
  }
}

export default persistReducer(
  {
    key: 'authentication',
    whitelist: ['user'],
    storage
  },
  reducer
)
